import { render, staticRenderFns } from "./DatosCompradoresComponent.vue?vue&type=template&id=7bac6ce8&scoped=true"
import script from "./DatosCompradoresComponent.vue?vue&type=script&lang=js"
export * from "./DatosCompradoresComponent.vue?vue&type=script&lang=js"
import style0 from "./DatosCompradoresComponent.vue?vue&type=style&index=0&id=7bac6ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bac6ce8",
  null
  
)

export default component.exports